export enum SituacaoDoProcesso {
  ProcessoCriado = 'ProcessoCriado',
  EnviandoDocumentos = 'EnviandoDocumentos',
  Finalizado = 'Finalizado',
}
